<template>
  <div id="wrap">
    <div class="dashboard clear">
      <Toolbar :menuInfo="menuInfo"></Toolbar>
      <div class="right">
        <Navigation :menuInfo="menuInfo"></Navigation>
        <div class="main">
          <div class="board clear">
            <div class="viewer">
              <div e-if="viewType === 'claimDetail'" class="detail">
                <ClaimDetail
                  class="claim-detail"
                  searchType="nonpayment"
                  :uID="uID"
                  :selectedID="selectedID"
                  @refresh="refresh"
                ></ClaimDetail>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-bitwise */
/* eslint-disable no-console */

import Toolbar from '@/components/include/Toolbar';
import Navigation from '@/components/include/Navigation';
import ClaimResultList from '@/components/claim/ClaimResultList';
import ClaimDetail from '@/components/claim/ClaimDetail';

export default {
  components: {
    Toolbar,
    Navigation,
    ClaimResultList,
    ClaimDetail,
  },
  data: () => ({
    tab: 0,
    menu: null,
    viewType: 'claimDetail',
    searchCondition: null,
    startTime: '',
    endTime: '',
    selectedID: null,
    menuInfo: {
      mainTitle: 'Nonpayment',
      mainName: '미결제 손실',
      subTitle: '',
      subName: '',
      company: null,
      division: null,
      device: null,
      tray: null,
      product: null,
    },
    downloadEvent: 0,
  }),
  created() {
    const token = this.$jwtDecode(this.$cookie.get('accessToken'));
    this.uID = token.uID;
    this.menu = this.$route.name;
  },
  methods: {
    refresh() {
      this.$router.go(-1);

      /*
      this.selectedID = null;
      this.viewType = 'claimList';
      */
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/claim/NonpaymentDetail.vue